import React from 'react';
import useSchemaStore from '../../store/schemaStore';

const ActionButtons = () => {
  const { addForeignKey, addUniqueKey, addIndex, toggleTableComment } = useSchemaStore();

  return (
    <>
      <div className="row">
        <div className="col-sm-2">
          <button className="btn btn-primary" onClick={addForeignKey}>
            Add Foreign Key
          </button>
        </div>
        <div className="col-sm-2">
          <button className="btn btn-primary" onClick={addUniqueKey}>
            Add Unique Key
          </button>
        </div>
        <div className="col-sm-2">
          <button className="btn btn-primary" onClick={addIndex}>
            Add Index
          </button>
        </div>
        <div className="col-sm-2">
          <button className="btn btn-primary" onClick={toggleTableComment}>
            Table Metadata
          </button>
        </div>
      </div>
    </>
  );
};

export default ActionButtons;